

















































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { getModule } from "vuex-module-decorators";
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import AddResourceButton from '@/views/ModelBuilder/AddResourceButton.vue';
import PasteOptions from '@/views/ModelBuilder/PasteOptions.vue';
import Dialogs from "@/store/modules/Dialogs";

const dialogsModule = getModule(Dialogs);

@Component({
    components: {
        ConfirmationDialog,
        AddResourceButton,
        PasteOptions,
    },
})
export default class AdditionalCommandsMenu extends Vue {
    @Prop()
    private btnClass!: string;

    @Prop({ default: false, type: Boolean })
    copy!: boolean;

    @Prop({ default: false, type: Boolean })
    paste!: boolean;

    @Prop({ default: false, type: Boolean })
    pasteAbove!: boolean;

    @Prop({ default: false, type: Boolean })
    pasteBelow!: boolean;

    @Prop({ default: false, type: Boolean })
    pasteDecision!: boolean;

    @Prop({ default: '', type: String })
    pasteResource!: string;

    @Prop({ default: false, type: Boolean })
    small: boolean;

    @Prop({ default: false, type: Boolean })
    xSmall: boolean;

    @Prop({ default: '', type: String })
    name: string;

    @Prop({ default: '', type: String})
    resourceId!: string;

    @Prop({ default: '', type: String})
    parentId!: string;

    private menuOpen = false;
    private showCrossDecisionDialog = false;
    @Watch('menuOpen')
    onMenuOpen(newVal: boolean) {
        if (newVal) {
            this.$emit('open');
        } else {
            this.$emit('closed');
        }
    }

    private async editFactorResource(resourceId: string, parentId: string) {
        await dialogsModule.createFactor({
            parentId: parentId,
            factorResourceId: resourceId,
        });
    }

    private decisionPaste(payload: any) {
        this.$emit('decision-paste', payload);
        this.menuOpen = false;
    }
    
}
